import tooltip from '@ui/Tooltip/component'
import bookingThumbnailZoom from 'assets/themes/campings/js/module/bookingThumbnailZoom'
import bookingReward from 'assets/themes/campings/js/page/red-booking/booking-common/bookingReward'
import sliders from 'assets/themes/campings/js/page/red-booking/booking-common/sliders'

document.addEventListener('DOMContentLoaded', function () {
  sliders()
  bookingThumbnailZoom()
  bookingReward()

  const freeModificationTriggerEl = document.querySelector<HTMLElement>('.trigger-tooltip-free-modification')
  const freeModificationTooltipEl = document.querySelector<HTMLElement>('.cart-recap__tooltip--free-modification')

  if (freeModificationTriggerEl && freeModificationTooltipEl) {
    tooltip(freeModificationTriggerEl, freeModificationTooltipEl)
  }

  const freeCancellationTriggerEl = document.querySelector<HTMLElement>('.trigger-tooltip-free-cancellation')
  const freeCancellationTooltipEl = document.querySelector<HTMLElement>('.cart-recap__tooltip--free-cancellation')

  if (freeCancellationTriggerEl && freeCancellationTooltipEl) {
    tooltip(freeCancellationTriggerEl, freeCancellationTooltipEl)
  }
})
